import React, { Component } from "react";
import { Button, Modal, DropdownButton, PageHeader, FormGroup, InputGroup, FormControl, ListGroupItem } from "react-bootstrap";
import { FontAwesomeIcon }           from '@fortawesome/react-fontawesome'
import LoaderButton                  from "../../components/LoaderButton";
import { Link, Routes }            from 'react-router-dom'
import YouTubeThumbnail            from "../../components/YouTubeThumbnail";
import ModalYouTubeVideo           from "../../components/modal/ModalYouTubeVideo";
import FooterLoadingBar            from "../../components/utils/FooterLoadingBar";
import SortDropdownBasicMenu       from "../../components/utils/SortDropdownBasicMenu";
import AddDropdownBasicMenu        from "../../components/utils/AddDropdownBasicMenu";
import RenderLander                from "../../components/utils/RenderLander";
import uniqueId                    from 'lodash/uniqueId';
import { EditorState, convertToRaw, convertFromRaw, ContentState } from 'draft-js';
import draftToHtml                 from 'draftjs-to-html';
import htmlToDraft                 from 'html-to-draftjs';
import { Editor }                  from 'react-draft-wysiwyg';
import { createHTMLMarkup }        from "../../utils/HTML";
import { Colors }                  from "../../utils/Colors";
import { invokeGetSearchHelpFAQs, invokeGetHelpListAll, invokeSetDeleteHelpFAQ } from "../../utils/AwsInvoke";
import "../../css/exercise/ExerciseList.css";
import "../../css/modal/ModalBasics.css";
import "../../css/help/AdminHelp.css";

import checkmark_green from '../../images/utils/checkmark_green.png';
import checkmark_gray  from '../../images/utils/checkmark_gray.png';

// uuidv1() = timestamp | uuidv4() = rnadom
const uuidv1 = require('uuid/v1');

export default class HelpAdminList extends Component {
    constructor(props) {
        super(props);

        var search_term = `${this.props.match.params.search_term}`;
        if(search_term === "&") search_term = "";

        this.state = {
              isLoading: false, // default is true
              numberOfRows: 100,
              sortBy: 1, // default sort by Name Asc
              searchMsg: "",
              searchTerm: search_term,
              helpResults: [],
              showLoadingBar:"none",
              pageOverlay: "none",
              showDeleteConfirmWin: false
        };
    }

    componentDidMount() {
        //this.searchHelpFAQs(); // search for existing keyword

        if (!this.props.isAuthenticated) {
            return;
        }

        try {

            this.getHelpList();
        } catch (e) {
            alert(e);
        }
    }

    getHelpList = async event => {
        this.setState({
            showLoadingBar: "inline",
            showDeleteConfirmWin: false
        })

        //// If user searched for an exercise and then hits the back button,
        //// take the user back to the search results page with the search term
        var search_term = this.state.searchTerm;

        // SortBy: name ASC, 2: name DESC, 3: date ASC, 4: date DESC
        if(search_term != "" && search_term != "&") {
            this.searchHelpFAQs(); // search for existing keyword
        } else {
            var results = await this.searchHelpFAQs(); //invokeGetHelpListAll();

            if(results) {
                this.setState({
                    helpResults: results,
                    isLoading: false,
                    showLoadingBar: "none",
                    showDeleteConfirmWin: false
                });
            } else
                this.setState({
                    showLoadingBar: "none",
                    showDeleteConfirmWin: false,
                    isLoading: false
                })
        }
    }

    clearSearchField = () => {

        this.setState({
            searchTerm: "", // reset search term if resetting exerc list
        })
    }

    searchHelpFAQs = async () => {
        /*var search_term = this.state.searchTerm;

        if(this.searchInput != undefined) {
            search_term = this.searchInput.value;

            if(search_term.length === 0) search_term = "&";

            this.props.history.replace("/exercise/listAll/"+search_term)

            //// RESET Search Textfield
            if(search_term === "&") {
                this.setState({
                    searchTerm: "", // reset search term if resetting exerc list
                    searchMsg: ""   // clear search message
                }, function () {
                    this.getHelpList();
                })
                return
            }
        }*/

        var search_term = this.searchInput.value;

        const results = await invokeGetSearchHelpFAQs(search_term.toLowerCase());
        console.log("results: " + results.length);
        if(results) {
            this.setState({
                helpResults: results,
                searchTerm: search_term,
                searchMsg: "You have "+results.length+ " results when searching for '" + search_term + "'.",
                isLoading: false,
                showLoadingBar: "none"
            });
        } else {
            this.setState({
                isLoading: false,
                showLoadingBar: "none"
            });
        }
    }


    handleCloseYouTubeWin = () => {
        this.setState({
            showYouTubeModal: false
        });
    }

    showYouTubeVideoModal = (yt_id, question) => {
        console.log("question " + question);
        this.setState({
            youTubeId: yt_id,
            pageOverlay: "inline",
            showYouTubeModal: true,
            question: question
        })
    }

    sortResults = (sort) => {
        this.setState({
            sortBy: sort,
            helpResults: null // reset exercises object otherwise the exercises list will re-render multiple times
        }, function(){
            this.getHelpList();
        })
    }

    handleKeyPress = (target) => {
        // Allow user to hit "Enter" when using Search box //
         if(target.charCode === 13)
            this.searchHelpFAQs();
    }

    handleGetDetail = (uid) =>  {
        this.props.history.push("/help/new/"+uid);
    }

    handleSetDeleteHelpId = (uid, e) =>  {

        e.preventDefault();

        this.setState({
            pageOverlay: "inline",
            showDeleteConfirmWin: true,
            helpId: uid
        });
    }

    renderHelpList(helpList) {
          var search_msg     = "";
          var tmp_search_msg = this.state.searchMsg;
          var help_results   = this.state.helpResults;

          /*var tmp_search_msg = this.state.searchMsg;
          search_msg = <div key={uniqueId()} className="exerciseHeaderButtons">
                            <span style={{position:"relative", top:"7px", left:"7px", fonySize: "19px"}}>
                             { tmp_search_msg }
                            </span>

                            { /*}<span className="pull-right">
                                <SortDropdownBasicMenu sortResults={this.sortResults.bind(this)} />
                            </span>/ }
                       </div>*/

            if(helpList != null && helpList != undefined) {
                  var list_arr = [];

                  if(help_results.length === 0) {
                      list_arr.push(<div key={uniqueId()} className="exerciseHeaderButtons">
                                        <span style={{position:"relative", top:"7px", left:"7px", fonySize: "19px"}}>
                                            { tmp_search_msg }
                                        </span>
                                   </div>);
                  } else {

                        for(var key in helpList) {
                            var answer  = helpList[key].answer;


                            list_arr.push(<span key = {uniqueId()}
                                                className="exerciseListRowLef"
                                          >
                                                    <span className="exerciseListSingleRowThumb"
                                                          style = {{cursor: "pointer", display:"inline-block", width:"100%", minHeight: 96, fontSize:"18px", border:"1px solid #ccc"}}
                                                    >
                                                        <span className="adminHelpListRowLeft">
                                                                <span className="exerciseListSingleRowThumb">
                                                                    <span onClick ={this.showYouTubeVideoModal.bind(this, helpList[key].youtube_id, helpList[key].question)}>
                                                                          <YouTubeThumbnail yt_id = {helpList[key].youtube_id} width={100} />
                                                                    </span>
                                                                </span>
                                                        </span>
                                                        <span   className="adminHelpListRowMiddle">
                                                            <div style={{display:"block", float:"left"}}
                                                                 onClick={this.handleGetDetail.bind(this, helpList[key].uid)}>

                                                                 <b>{parseInt(key)+1}. { helpList[key].question }</b>
                                                            </div>
                                                            <br/>
                                                        <div style={{display:"block", width:"100%", float:"left"}}
                                                                 onClick={this.handleGetDetail.bind(this, helpList[key].uid)}>
                                                                 <textarea className = "helpAdminList"
                                                                           rows      = { 4 }
                                                                           value     = { helpList[key].answer }
                                                                           readOnly
                                                                        />
                                                                    { /*}<div dangerouslySetInnerHTML={createHTMLMarkup( helpList[key].answer)} />*/ }
                                                            </div>
                                                        </span>
                                                        <span style={{float:"right", position:"relative", top: 0, right:40, zIndex:1150}}
                                                              onClick={this.handleSetDeleteHelpId.bind(this, helpList[key].uid)}>
                                                              <span className="glyphicon glyphicon-remove-circle glyphiconDeleteExercBtn"
                                                                    style = {{color: Colors.delete_button_bg}}/>
                                                        </span>
                                                    </span>
                                            </span>)
                        }
                  }
                  return list_arr;
             }
    }

    handleAddNewHelp = event => {
        event.preventDefault();

        this.props.history.push(event.currentTarget.getAttribute("href"));
    }

    //// Temp solution for mobile browser back button issue described above;
    //// works great but having issues with the popup confirm box
    /*handleNewDeleteExercise = event => {
        event.preventDefault();
        this.props.history.push(event.currentTarget.getAttribute("href"));
    }*/

    getNext100Results = () => {
        var tmp_rows = this.state.numberOfRows;
        tmp_rows = tmp_rows + 100;

        this.setState({
            numberOfRows: tmp_rows
        }, function(){
            this.getHelpList();
        })
    }

    renderHelp() {
        var next_100;

        if(!this.state.isLoading)
            next_100 = <span style={{display:"inline-block", width:"100%", textAlign:"center", fontSize:"18px", cursor:"pointer"}} onClick={() => this.getNext100Results()}> { /*Next 100 results >>*/ }</span>

        if(this.state.searchMsg != "") next_100 = ""; // if user is searching for an exercise, hide "next 100 results" msg

        return (
              <div className="programs">
                <PageHeader>
                            <FontAwesomeIcon icon="question-circle" style={{ position:"relative", top:8, fontSize: '1.6em', color: Colors.primary_color, paddingRight:"16px" }}/>
                            Help
                            <Button bsStyle = "default"
                                    title   = "Add New"
                                    style   = {{float:"right", position: "relative", top: 13, padding:10, borderRadius: "15px !important"}}
                                    onClick = {this.handleAddNewHelp}
                                    href    = "/help/new/&"
                             >
                                Add New
                            </Button>
                </PageHeader>
                <div className="exerciseHeaderSearchBar" style={{display: "inline-block", width:"100%", height:"100%"}}>
                     <span>
                            <FormGroup>
                                <InputGroup>
                                  <FormControl key = {uniqueId()}
                                               type="text"
                                               placeholder=""
                                               defaultValue={this.state.searchTerm}
                                               inputRef={ref => { this.searchInput = ref; }}
                                               onKeyPress={this.handleKeyPress}
                                           />

                                    <span className="glyphicon glyphicon-remove-circle searchInputClearBtn"
                                          onClick={() => this.clearSearchField()}
                                    />
                                    <InputGroup.Button>
                                      <Button style={{ display:"inline-block", height:"34px",backgroundColor: Colors.search_button_bg, color:"white", borderRadiusInputTopRight: "5px" }} onClick={() => this.searchHelpFAQs()}>Search</Button>
                                    </InputGroup.Button>
                                </InputGroup>
                            </FormGroup>
                       </span>

                       <div className="adminHelpListContainer">
                           {!this.state.isLoading && this.renderHelpList(this.state.helpResults)}
                       </div>
                 </div>
                <br/>
                { next_100 }
                <br/><br/><br/><br/>
              </div>
        );
    }

    async deleteHelpFAQ () {
        this.setState({ isLoading: true /*pageOverlay: "none", showDeleteConfirmWin: false*/ });

        var results = await invokeSetDeleteHelpFAQ(this.state.helpId);

        if(results.status) this.getHelpList();
          else this.getHelpList();
    }

    handleCloseWin = (action) => {
        if(action === "delete") this.deleteHelpFAQ();
            else this.setState({ pageOverlay: "none", showDeleteConfirmWin: false });
    }


    render() {
        return (
              <div className="ProgramList">
                {this.props.isAuthenticated ? this.renderHelp() : <RenderLander />}

                <FooterLoadingBar text={"Retieving Exercises ..."}
                                  showLoadingBar={this.state.showLoadingBar}/>
                  {this.state.showYouTubeModal ?
                      <ModalYouTubeVideo
                          pageOverlay      = {this.state.pageOverlay}
                          showYouTubeModal = {this.state.showYouTubeModal}
                          exercise_name    = {this.state.question}
                          youTubeId        = {this.state.youTubeId}
                          closeYouTubeWin  = {this.handleCloseYouTubeWin}
                          showSummary      = {false}
                          />
                  : null}
                  <div>
                        <span className="pageOverlay" style={{display:this.state.pageOverlay}}></span>
                        <Modal
                               show            = {this.state.showDeleteConfirmWin}
                               onHide          = {() => this.handleCloseWin("close")}
                               size            = "lg"
                               centered        = "true"
                               aria-labelledby = "contained-modal-title"
                               className       = "modalBasics"
                             >
                               <Modal.Header closeButton>
                                   <Modal.Title id="contained-modal-title">
                                       <FontAwesomeIcon icon="info-circle" className="modalAlertIcon" />
                                       <span className="modalBasicsTitle">
                                           Confirm Help Section Deletion
                                       </span>
                                   </Modal.Title>
                               </Modal.Header>
                               <Modal.Body>
                                   <span className="modalAlertBody">
                                   Are you sure you want to delete this help section?
                                    </span>
                               </Modal.Body>
                               <Modal.Footer>
                                       <Button className="modalBasicsBtnClose" onClick={() => this.handleCloseWin("close")}>Cancel</Button>
                                       <span className="modalBasicsFooterXPosSpacer"/>
                                       <LoaderButton
                                           bsSize    = "large"
                                           //disabled  = {!this.validateForm()}
                                           //type      = "submit"
                                           btncolor  = {Colors.delete_button_bg}
                                           height    = {38}
                                           width     = {125}
                                           isLoading = {this.state.isLoading}
                                           text        = "Yes, Delete"
                                           loadingText = "" //"Deleting program…"
                                           onClick     = {() => this.handleCloseWin("delete")}
                                         />
                               </Modal.Footer>
                         </Modal>
                  </div>
              </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/screens/help/HelpAdminList.js